import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import FormController from '../../form/FormController'
import ProductEditStore from '../../../Product/ProductEditStore'
import Panel from '../../../UniformComponents/Panel'
import RecordTag from '../../RecordTags'

@observer
class ProductNew extends Component {
    constructor(props) {
        super(props)
        this.fields = {}
        this.productEditStore = new ProductEditStore(props.store)
    }

    async componentDidMount() {
        const { wizardStore } = this.props
        await this.productEditStore.initProduct(
            0, wizardStore.industry, wizardStore.surveyType, wizardStore.goBack,
        )
        wizardStore.handleValidate = this.validate
    }

    validate = () => {
        const { wizardStore } = this.props
        const { product } = this.productEditStore
        const isValid = wizardStore.validate(this.fields, product)
        if (isValid) wizardStore.product = product
        wizardStore.productRecordTags = this.productEditStore.recordTags
        wizardStore.productAvailableTags = this.productEditStore.availableTags
        return isValid
    }

    renderLoader = () => (
        <div className="loader" />
    )

    render() {
        return (
            <Panel cssClass="stage-card overflow-visible">
                <div id="product-new">
                    {
                        this.productEditStore.formLoading ? this.renderLoader()
                            : (
                                <div>
                                    <FormController
                                        fields={this.fields}
                                        formFields={this.productEditStore.formFields}
                                        setField={this.productEditStore.setField}
                                    />

                                    <RecordTag
                                        values={this.productEditStore.recordTags}
                                        availableTags={this.productEditStore.availableTags}
                                        onBlur={this.productEditStore.setTag}
                                        register={this.register}
                                        unregister={this.unregister}
                                    />
                                </div>
                            )
                    }
                </div>
            </Panel>
        )
    }
}

export default ProductNew
